module.exports = __webpack_public_path__ + "img/user.d9474b52.png";